import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { useApiServices } from '../api/services';
import { useAuth } from './useAuth';

const NOTIFICATIONS_KEY = ['notifications'];

export function useNotifications(options?: { unreadOnly?: boolean; limit?: number }) {
  const { notifications } = useApiServices();
  const { organization } = useAuth();
  return useQuery({
    queryKey: [...NOTIFICATIONS_KEY, 'list', organization?.id, options],
    queryFn: () => notifications.list(options),
    refetchInterval: 30_000,
  });
}

export function useUnreadNotificationCount() {
  const { notifications } = useApiServices();
  const { organization } = useAuth();
  return useQuery({
    queryKey: [...NOTIFICATIONS_KEY, 'unread-count', organization?.id],
    queryFn: () => notifications.unreadCount(),
    refetchInterval: 30_000,
  });
}

export function useMarkNotificationRead() {
  const { notifications } = useApiServices();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => notifications.markRead(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: NOTIFICATIONS_KEY });
    },
  });
}

export function useMarkAllNotificationsRead() {
  const { notifications } = useApiServices();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => notifications.markAllRead(),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: NOTIFICATIONS_KEY });
    },
  });
}
